import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { ApiService } from "./api.service";

@Injectable()
export class AuthGuardService {
	private router = inject(Router);
	private api = inject(ApiService);


	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user) {
			return true;
		}

		this.router.navigate(["/login"]);
		return false;
	}
}

@Injectable()
export class AuthGuardSupportService {
	private router = inject(Router);
	private api = inject(ApiService);


	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && (this.api.user.support || this.api.user.role === "admin" || this.api.user.role === "master")) {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}

@Injectable()
export class AuthGuardOrgAdminService {
	private router = inject(Router);
	private api = inject(ApiService);


	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && (this.api.user.role === "orgadmin" || this.api.user.role === "admin" || this.api.user.role === "master")) {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}

@Injectable()
export class AuthGuardGlobalAdminService {
	private router = inject(Router);
	private api = inject(ApiService);


	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && (this.api.user.role === "admin" || this.api.user.role === "master")) {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}

@Injectable()
export class AuthGuardMasterService {
	private router = inject(Router);
	private api = inject(ApiService);


	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && this.api.user.role === "master") {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}
